import { PaApi, baseOpts, processSuccess } from '@/services/PaApi'

// Define expiry intervals by milliseconds
const expireAfter = {
  'settings': 3400000
}

function sortedSettings (a, b) {
  var nameA = a.name.toUpperCase()
  var nameB = b.name.toUpperCase()

  if (nameA < nameB) {
    return -1
  }

  if (nameA > nameB) {
    return 1
  }

  return 0
}

export function storeLocalSettings (state) {
  localStorage.setItem(
    'settings',
    JSON.stringify(
      state.settings.filter(
        setting => setting.is_public
      ).map(setting => {
        return {
          name: setting.name,
          val: setting.val
        }
      })
    )
  )
  storeRetrievedAt('settings')
}

function storeRetrievedAt (item) {
  let items = getRetrievedAt() || {}
  items[item] = new Date().getTime()

  localStorage.setItem('retrievedAt', JSON.stringify(items))
}

function getRetrievedAt () {
  return JSON.parse(
    localStorage.getItem('retrievedAt') || '{}'
  )
}

function getRetrievedAtItem (item) {
  return getRetrievedAt()[item]
}

function getLocalSettings () {
  return JSON.parse(
    localStorage.getItem('settings') || '[]'
  )
}

const defaultBrandings = {
  'brand_name': 'PuzzleAnywhere'
}

function getLocalBrandings () {
  const parameterize = require('parameterize')
  const settings = getLocalSettings()
  let brandings = defaultBrandings

  if (settings.length) {
    settings.map(setting => {
      brandings[parameterize(setting.name, 255, '_')] = setting.val
    })
  }

  return brandings
}

export const SettingModule = {
  namespaced: true,

  state: {
    // Brandings contain settings using each public setting's slug
    // as the object key.
    brandings: {},
    config: {},
    contributors: [],
    loaders: {
      config: false,
      settings: true
    },
    settings: []
  },

  getters: {
    settingsObject (state) {
      const parameterize = require('parameterize')

      const settings = {}
      state.settings.map(setting => {
        settings[parameterize(setting.name, 255, '_')] = setting.val
      })

      return settings
    },

    // Requires a slug to be passed in, instead of the setting's display name.
    setting: (state) => (slug) => {
      return state.settings.find(setting => setting.slug === slug)
    },

    // Unlike global getLocalSettlings, this returns an Object with settings
    // name/value pairs.
    getLocalSettings (state, getters) {
      const parameterize = require('parameterize')

      let settings = {}
      getLocalSettings().map(setting => {
        settings[parameterize(setting.name, 255, '_')] = setting.val
      })

      return settings
    }
  },

  actions: {
    async getSettings ({ commit, state }) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        '/admin/settings'
      ).then((resp) => {
        commit('storeSettings', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async getPublicSettings ({ commit, state }) {
      commit('LoaderModule/setLoaders', {
        'settings': true
      }, { root: true })

      await PaApi().get(
        '/settings'
      )
        .then((resp) => {
          commit('storeSettings', resp)
        })
        .catch(() => {
          commit('storeBrandingsFromLocalstore')
        })
        .finally(() => {
          commit('LoaderModule/setLoaders', {
            'settings': false
          }, { root: true })
        })
    },

    async exportSettings ({ commit, state }) {
      commit('setLoading', true, { root: true })

      return await PaApi().get(
        '/admin/settings/export'
      ).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async importSettings ({ commit, state }, form) {
      commit('setLoading', true, { root: true })

      return await PaApi().post(
        '/admin/settings/import', form
      ).then((resp) => {
        commit('storeSettings', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async refreshSettings ({ commit, state }) {
      commit('setLoading', true, { root: true })

      return await PaApi().post(
        '/admin/settings/refresh'
      ).then((resp) => {
        commit('storeSettings', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async getConfig ({ commit, state }) {
      commit('setLoading', true, { root: true })

      return await PaApi().get(
        '/admin/about'
      ).then((resp) => {
        commit('storeConfig', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async previewContributors ({ commit, state }, form) {
      commit('setLoading', true, { root: true })

      return await PaApi().post(
        '/admin/preview_contributors', form
      ).then((resp) => {
        commit('storeContributors', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async importContributors ({ commit, state }, form) {
      commit('setLoading', true, { root: true })

      return await PaApi().post(
        '/admin/import_contributors', form
      ).then((resp) => {
        commit('storeContributors', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async refreshIfStale ({ commit, state }, settingsType) {
      const retrievedAt = getRetrievedAtItem(settingsType) || 0

      if (new Date(retrievedAt + expireAfter.settings) < new Date().getTime()) {
        this.dispatch('SettingModule/refreshSettings')
      }
    }
  },

  mutations: {
    storeConfig (state, payload) {
      state.config = payload.data
    },

    storeSettings (state, payload) {
      state.settings = processSuccess(payload, baseOpts)

      state.settings.sort(sortedSettings)
      storeLocalSettings(state)

      state.brandings = getLocalBrandings()
    },

    storeBrandingsFromLocalstore (state) {
      state.brandings = getLocalBrandings()
    },

    storeContributors (state, payload) {
      state.contributors = processSuccess(payload, baseOpts)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/SettingModule.js